module.exports = __webpack_public_path__ + "static/media/Grabbi_social_engagement.85800a51.png";